import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import queryString from 'query-string';

import store from '../../store';
import { transactionsRestHooks } from '../../store/Transactions/TransactionsSlice';
import { storesRestHooks } from '../../store/Stores/StoresSlice';
import useTransactionsData from '../../hooks/Reports/useTransactionsData';
import DatePresenter from '../../presenters/DatePresenter';
import { ACTIVE } from '../../presenters/TransactionPresenter';
import TransactionsFilters from '../../components/TransactionsFilters';
import { FIRST_PAGE } from '../../constants/pagination';
import FETCH_STATUSES from '../../constants/fetchStatuses';

import TransactionsData from './components/TransactionsData';
import Transactions from './components/Transactions';

const TransactionsDashboardContainer = () => {
  const queryParams = queryString.parse(window.location.search);
  const { byRefundGroupId, refundStatusEq } = queryParams;
  const initialParams = {
    afterDate: DatePresenter.oneMonthAgo(),
    beforeDate: DatePresenter.today(),
    storeIdEq: '',
    byUser: '',
    nameCont: '',
    withCashbacks: false,
    byLocation: 'all',
    stateEq: ACTIVE,
    byMerchantNames: '',
    onlyOriginals: true,
    nameNotIContAll: '',
    byRefundGroupId: byRefundGroupId || '',
    refundStatusEq: refundStatusEq || '',
  };
  const [searchParams, setSearchParams] = useState({
    q: initialParams,
    page: FIRST_PAGE,
  });

  const handlePageChange = ({ selected }) => {
    const newParams = { ...searchParams, page: selected + 1 };
    setSearchParams(newParams);

    loadTransactions(newParams);
  };

  const {
    transactions: { loadingStatus, items: transactions, meta },
    loadTransactions,
  } = transactionsRestHooks.use();

  const {
    transactionsData,
    loadTransactionsData,
    transactionsDataLoadingState,
  } = useTransactionsData();

  const {
    loadStores,
    stores: { loadingStatus: storesLoadingState, items: stores },
  } = storesRestHooks.use();

  const loadData = (newParams) => {
    loadTransactions(newParams);
    loadTransactionsData(newParams);
  };

  useEffect(() => {
    loadStores();
  }, []);

  return (
    <div className="transactions">
      <h2>Transactions Dashboard</h2>
      <TransactionsFilters
        searchParams={searchParams}
        onSearchParamsChange={setSearchParams}
        stores={stores}
        storesLoadingState={storesLoadingState}
        onLoadData={loadData}
      />
      {transactionsDataLoadingState !== FETCH_STATUSES.idle && (
        <TransactionsData
          transactionsData={transactionsData}
          loadingState={transactionsDataLoadingState}
        />
      )}
      {loadingStatus !== FETCH_STATUSES.idle && (
        <Transactions
          transactions={transactions}
          meta={meta}
          onPageChange={handlePageChange}
          loadingState={loadingStatus}
        />
      )}
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(TransactionsDashboardContainer);
